import constants from '@/commons/constants';
const filters = {
    /**
     * 常量过滤器，接受常量代码
     * @param classCode
     * @param input
     * @returns {*}
     */
    constantsFilter (input, classCode) {
        if (!input && input !== 0 && input !== '0') {
            return '';
        }
        if (classCode !== undefined && input !== undefined) {
            return constants[classCode][input];
        } else {
            return '';
        }
    },

    /**
     * 格式化时间
     * @param {*} value
     * @param {*} type
     */
    formateDateFilter (value, type) {
        let newDate = new Date();
        let currentYear = newDate.getFullYear();
        newDate.setTime(value);
        let valueYear = newDate.getFullYear();
        if (type === 'yyyy-MM-dd') {
            if (currentYear > valueYear) {
                return newDate.format('yyyy-MM-dd');
            } else {
                return newDate.format('MM-dd');
            }
        } else {
            return newDate.format(type);
        }
    },

    /**
     * 隐藏手机号
     * @param {*} value
     */
    telFormateFilter (value) {
        if (value) {
            return value.substr(0, 3) + '****' + value.substr(7, 11);
        } else {
            return '--';
        }
    },

    /**
     * 视频状态
     * @param {*} value
     */
    videoStatueFn (value) {
        for (let k in constants.VIDEO_STATUS) {
            if (Number.parseInt(value, 10) === Number.parseInt(k, 10)) {
                return constants.VIDEO_STATUS[k];
            }
        }
    },

    /**
     * 空值处理
     * @param {*} value
     */
    noDataFilter (value) {
        switch (value) {
        case undefined:
            return '--';
        case null:
            return '--';
        case '':
            return '--';
        default:
            return value;
        }
    }
};

const install = function (Vue) {
    for (let key of Object.keys(filters)) {
        Vue.filter(key, filters[key]);
    }
};

export default install;
